import {Action, createReducer, on} from '@ngrx/store';
import {
  IndustriesList,
  IndustriesListError,
  IndustriesListSuccess,
  IndustryCreate,
  IndustryCreateSuccess,
  IndustryCreateError,
  IndustryUpdate,
  IndustryUpdateSuccess,
  IndustryUpdateError,
  IndustryDelete,
  IndustryDeleteSuccess,
  IndustryDeleteError,
  ResetIndustriesState
} from '@app/stores/industries/industries.actions';
import { initialIndustryState } from '@app/stores/industries/industries.state';

const generateReducer = createReducer(initialIndustryState,
  on(IndustriesList, (state) => ({
    ...state,
    industry: null,
    paginatedIndustries: null,
    success: '',
    error: ''
  })),
  on(IndustriesListSuccess, (state, {paginatedIndustries}) => ({
    ...state,
    industry: null,
    paginatedIndustries,
    success: '',
    error: ''
  })),
  on(IndustriesListError, (state, {error}) => ({
    ...state,
    industry: null,
    paginatedIndustries: null,
    success: '',
    error
  })),
  on(IndustryUpdate, (state) => ({
    ...state,
    industry: null,
    success: '',
  })),
  on(IndustryUpdateSuccess, (state) => ({
    ...state,
    success: 'Industry updated successfully',
    error: ''
  })),
  on(IndustryUpdateError, (state, {error}) => ({
    ...state,
    industry: null,
    error
  })),
  on(IndustryDelete, (state) => ({
    ...state,
    industry: null,
    success: '',
  })),
  on(IndustryDeleteSuccess, (state) => ({
    ...state,
    success: 'Industry deleted successfully',
    error: ''
  })),
  on(IndustryDeleteError, (state, {error}) => ({
    ...state,
    industry: null,
    error
  })),
  on(IndustryCreate, (state) => ({
    ...state,
    industry: null,
    success: '',
  })),
  on(IndustryCreateSuccess, (state) => ({
    ...state,
    industry: null,
    success: 'Industry Created successfully',
  })),
  on(IndustryCreateError, (state, {error}) => ({
    ...state,
    industry: null,
    error
  })),

  on(ResetIndustriesState, (state, {params}) => ({
    ...state,
    ...params
  })),
);

export function industriesReducer(state = initialIndustryState, action: Action) {
  return generateReducer(state, action);
}
